import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

export const StyledDividerWidthText = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.borderInput};
  h2 {
    white-space: nowrap;

    @media (max-width: ${gridBreakPoints.md}) {
      white-space: wrap;
    }
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: #999;
    margin: 20px;
    margin-right: 5px;
    opacity: 0.2;
  }
`
